import { setHideTrash } from '../../search-and-filter-schema/protected';
const updateTrashToggle = (filters, filterValue) => {
  return setHideTrash(filterValue, filters);
};
export default updateTrashToggle;